var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.571 14.464H30.5352C29.6476 14.464 28.9281 15.1836 28.9281 16.0712C28.9281 16.9588 29.6476 17.6784 30.5352 17.6784H38.571C39.4586 17.6784 40.1782 18.3979 40.1782 19.2856V40.1786C40.1782 41.0663 39.4586 41.7858 38.571 41.7858H6.42791C5.54027 41.7858 4.82072 41.0663 4.82072 40.1786V19.2855C4.82072 18.3978 5.54027 17.6783 6.42791 17.6783H14.4637C15.3513 17.6783 16.0708 16.9588 16.0708 16.0711C16.0708 15.1835 15.3513 14.4639 14.4637 14.4639H6.42791C3.76509 14.4639 1.60645 16.6226 1.60645 19.2854V40.1784C1.60645 42.8413 3.76509 44.9999 6.42791 44.9999H38.571C41.2338 44.9999 43.3924 42.8413 43.3924 40.1784V19.2855C43.3924 16.6227 41.2338 14.464 38.571 14.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6722 8.5063L23.6364 0.470557C23.0089 -0.156893 21.9915 -0.156893 21.3639 0.470557L13.3281 8.5063C12.7115 9.14477 12.7292 10.1622 13.3676 10.7788C13.9905 11.3803 14.9778 11.3803 15.6007 10.7788L20.8931 5.48639V32.1428C20.8931 33.0304 21.6126 33.75 22.5003 33.75C23.3879 33.75 24.1074 33.0304 24.1074 32.1428V5.48648L29.3999 10.7789C30.0383 11.3955 31.0557 11.3778 31.6723 10.7393C32.2737 10.1165 32.2737 9.12914 31.6722 8.5063Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2fe54a6732d3acf042eca2684c6cc285.svg";
export { ForwardRef as ReactComponent };